/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// UI widget for inline photo uploader field
//
// A thin wrapper around jquery-fileupload, mostly to centralize sane defaults

namespace('Slzr.UI.PhotoUploader', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  return (function() {
    let UPLOAD_URL = undefined;
    const Cls = (exports.Input = class Input {
      static initClass() {
        UPLOAD_URL = '/photos/upload';
  
        this.prototype.default_options = {
          url: UPLOAD_URL,
          autoUpload: true,
          acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
          dataType: 'json',
          statusElement: null,
          type: 'POST',
          pasteZone: null
        };
      }

      // Initialize this instance of the photo uploader on +element+
      constructor(element, options) {
        this.bind = this.bind.bind(this);
        this._bindEvents = this._bindEvents.bind(this);
        this.element = $(element);
        this.options = $.extend({}, this.default_options, options);

        this.status_el = this.options.statusElement ? $(this.options.statusElement) : $(this.element.data('status'));

        // Attach the upload handler
        this.element.fileupload(this.options);
        this._bindEvents();
      }

      // Bind an event to the input element
      bind(event, callback) {
        this.element.on(event, callback);
        return this;
      }

      // Attach listeners for handling the status thing
      _bindEvents() {
        this.element.on('fileuploadsend', (event, data) => {
          // debugger
          return setTimeout((() => this.status_el.html('Uploading...').removeClass('error').show()), 0);
        });
          // @status_el.html('Uploading...').removeClass('error').show()

        this.element.on('fileuploaddone', (event, data) => {
          if (data.result.status === 'error') {
            const message = data.result.error === 'not_an_image' ?
                        "Uploaded file must be an image (JPG, GIF, or PNG)"
                      : data.result.error === 'image_too_big' ?
                        "Image must be smaller than 10MB"
                      : data.result.error === 'image_dimensions_too_big' ?
                        "Image must be smaller than 5000x5000 pixels"
                      :
                        data.result.message;

            return this.status_el.html(message).addClass('error').show();
          } 
            return this.status_el.html('Uploaded').removeClass('error').hide();
          
        });

        return this.element.on('fileuploadfail', (event, data) => {
          if (typeof console !== 'undefined' && console !== null) {
            console.error('Error uploading photo', event, data);
          }
          return this.status_el.html('Error uploading photo').addClass('error').show();
        });
      }
    });
    Cls.initClass();
    return Cls;
  }());
});

      // Don't allow pastes if an input element is focused
      // @element.bind 'fileuploadpaste', (event, data) =>
      //   active_element = $(document.activeElement)
      //   if !$(event.target).is(@element) && active_element.is('div.editable, .cke_editable, textarea, input, select') && !active_element.is('input[type="file"]')
      //     event.stopPropagation()
      //     event.preventDefault()
      //     return false
      //   true